import Fetcher from '../../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../../constants'
import {
  RebateFacilityGroup,
  RebatePeriod,
  UpdateRebatePeriodFacilitiesPayload
} from './types'

const fetcher = new Fetcher({})

export const getRebatePeriods = async (contractId: string, rebateId: string) =>
  fetcher.request<unknown, RebatePeriod[]>({
    url: `${API_DICTIONARY.CONTRACTS}${contractId}/${API_DICTIONARY.REBATE}${rebateId}/${API_DICTIONARY.PERIODS}`,
    method: HTTP_METHODS.GET
  })

const getRebatePeriodFacilitiesUrl = (
  contractId: string,
  rebateId: string,
  periodId: string
) =>
  `${API_DICTIONARY.CONTRACTS}${contractId}/${API_DICTIONARY.REBATE}${rebateId}/${API_DICTIONARY.PERIODS}${periodId}/${API_DICTIONARY.FACILITIES}`

export const getRebatePeriodFacilities = async (
  contractId: string,
  rebateId: string,
  periodId: string
) =>
  fetcher.request<unknown, RebateFacilityGroup[]>({
    url: getRebatePeriodFacilitiesUrl(contractId, rebateId, periodId),
    method: HTTP_METHODS.GET
  })

export const updateRebatePeriodFacilities = async (
  contractId: string,
  rebateId: string,
  periodId: string,
  payload: UpdateRebatePeriodFacilitiesPayload
) =>
  fetcher.request<UpdateRebatePeriodFacilitiesPayload, Record<string, never>>({
    url: getRebatePeriodFacilitiesUrl(contractId, rebateId, periodId),
    method: HTTP_METHODS.PUT,
    data: payload
  })
